import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Casos críticos só existem no tenant com a integração e para quem pode ler. Aberto por URL fora
 * disso, vai para a lista de ocorrências em vez de mostrar uma página que só dá erro.
 */
export const criticalCaseGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.criticalCasesEnabled() && auth.can('critical-case:read')) return true;
  return router.createUrlTree(['/', route.paramMap.get('tenant') ?? auth.currentTenant(), 'ocorrencias']);
};
